/* eslint-disable import/order */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable camelcase */
import React, { useEffect, useMemo, useState } from 'react'
import axios from 'axios/index'
import {
  Box,
  Divider,
  Grid,
  TextField,
  Typography,
  makeStyles,
  withStyles,
} from '@material-ui/core'
import config from '../../../config'
import styles from '../../../resources/theme/global'

import { Filter } from './Filter'
import { isValid, parseISO } from 'date-fns'
import CardSection from './CardSection'
import { fetchDashboard } from '../DashboardLeadsActions'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import colors from '../../../assets/colors'
import PeriodFilter, {
  PERIODS,
  getPeriodRange,
} from '../../../components/hooks/BaseButtonGroup'
import {
  mdiAccountFilter,
  mdiAccountMultipleCheck,
  mdiCalendarMultipleCheck,
  mdiCurrencyUsd,
  mdiPercent,
} from '@mdi/js'
import AditionalBox from './AditionalBox'
import Icon from '@mdi/react'
import CardKnow from './CardKnow'
import Chart from 'react-google-charts'
import { fetchSchedulesRelatoryInit } from '../../schedulesRelatory/SchedulesRelatoryActions'
import { fetchServicesRelatoryInit } from '../../servicesRelatory/ServicesRelatoryActions'
import SelectField from '../../components/SelectField'
import { hasRole } from '../../../util/utils'

const useStyles = makeStyles({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  boxChart: {
    border: `1px solid ${colors.graylight}`,
    height: '100%',
    padding: '10px',
    borderRadius: '10px',
  },
  qtdOriginLeads: {
    color: colors.primary,
    fontSize: '40px',
    display: 'flex',
    textAlign: 'start',
    alignItems: 'center',
    fontWeight: 700,
  },
})

const isValidDate = value =>
  /^\d{4}-\d{2}-\d{2}$/.test(value || '') && isValid(parseISO(value))

// filtros vivem na query string para sobreviver a reload e navegação
const parseFilters = search => {
  const params = new URLSearchParams(search)
  const period = PERIODS.includes(params.get('period'))
    ? params.get('period')
    : 'day'
  const dateStart = params.get('date_start')
  const dateEnd = params.get('date_end')

  return {
    period,
    ...(isValidDate(dateStart) && isValidDate(dateEnd)
      ? { date_start: dateStart, date_end: dateEnd }
      : getPeriodRange(period)),
    attendance_id: params.get('attendance_id') || '',
  }
}

const LeadsDashboard = styles => {
  const dispatch = useDispatch()
  const style = useStyles()
  const { classes } = styles
  const [chartData, setChartData] = useState([])
  const attendances = useSelector(state => state.services_relatory.attendances)
  const roles = useSelector(state => state.auth.role)

  const history = useHistory()
  const location = useLocation()

  const filters = useMemo(
    () => parseFilters(location.search),
    [location.search]
  )

  const setFilters = next => {
    const params = new URLSearchParams()

    params.set('period', next.period)
    params.set('date_start', next.date_start)
    params.set('date_end', next.date_end)
    if (next.attendance_id) params.set('attendance_id', next.attendance_id)

    history.replace(`${location.pathname}?${params.toString()}`)
  }

  const selectedAttendance =
    attendances?.find(item => String(item.id) === filters.attendance_id) || null

  // investimento é pago mensalmente: em dia/semana as métricas ficam distorcidas
  const monthVision = !['month', 'custom'].includes(filters.period)

  const [data, setData] = useState([])

  const fetchDashboardData = async event => {
    const resp = await dispatch(
      fetchDashboard({
        date_start: filters.date_start,
        date_end: filters.date_end,
        attendance_id: filters.attendance_id,
      })
    )

    if (resp) {
      setData(resp)
    }
  }

  const initGraphicData = () => {
    if (!data?.know_way_metrics?.know_ways?.length > 0) return setChartData([])

    setChartData([])
    data?.know_way_metrics?.know_ways?.map(origin => {
      setChartData(prevState => [...prevState, [origin?.name, origin?.value]])
    })
  }

  useEffect(() => {
    fetchDashboardData()
  }, [filters.date_start, filters.date_end, filters.attendance_id])

  useEffect(() => {
    dispatch(fetchServicesRelatoryInit(1, null, 1))
  }, [])

  useEffect(() => {
    initGraphicData()
  }, [data])

  return (
    <Grid container style={{ marginBottom: '16px' }}>
      <Grid container justifyContent="space-between">
        <Grid item xs>
          <Typography
            variant="h4"
            style={{ fontSize: '20px' }}
            color={colors.primary}
          >
            Dashboard Leads
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Grid
            container
            spacing={4}
            justifyContent="flex-end"
            alignItems="flex-end"
          >
            {hasRole('gerente_lavanderia', roles) && (
              <Grid item xs={3} sm="6" md="3">
                <SelectField
                  options={attendances}
                  setForm={(name, value) => {
                    setFilters({
                      ...filters,
                      attendance_id: value?.id || '',
                    })
                  }}
                  data={selectedAttendance}
                  name="attendance"
                  variant="standard"
                  label="Atendente"
                  fullWidth
                />
              </Grid>
            )}

            <Grid item>
              <PeriodFilter filters={filters} setFilters={setFilters} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={6} style={{ marginTop: '1em' }}>
        <Grid item sm={10} md={9}>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12}>
              <CardSection
                data={data?.leads_period}
                title={
                  <span>
                    Leads no <br /> período
                  </span>
                }
                isMonetary
                showPercentage
                icon={mdiAccountMultipleCheck}
                isLinkCard
                classes={classes}
                finalDate={filters.date_end}
                startDate={filters.date_start}
              />
            </Grid>

            <Grid item xs={12}>
              <CardSection
                data={data?.agendaments_metrics?.agendaments}
                title={
                  <span>
                    Agendamentos <br /> no período
                  </span>
                }
                isMonetary
                icon={mdiCalendarMultipleCheck}
                isLinkRelatory
                classes={classes}
                finalDate={filters.date_end}
                startDate={filters.date_start}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item sm={2} xs={12} md={3}>
          <Grid container className={style.boxChart}>
            <Chart
              chartType="PieChart"
              width="100%"
              data={[['Como conheçeu', 'Quantidade'], ...chartData]}
              height="100%"
              options={{
                is3D: 'true',
                legend: {
                  position: 'none',
                },
                chartArea: {
                  width: '100%',
                  height: '100%',
                },
              }}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={3} style={{ marginTop: '1em' }}>
        <Grid item xs={12}>
          <Box
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '24px',
              height: '100%',
            }}
          >
            <AditionalBox
              title="CAC"
              isDecimal
              top="R$"
              value={data?.marketing_metrics?.cac}
              disabled={monthVision}
            />

            <AditionalBox
              title="ROAS"
              isDecimal
              disabled={monthVision}
              value={data?.marketing_metrics?.roas}
            />
            <AditionalBox
              title={
                <span>
                  MÉDIA DE
                  <br />
                  DESCONTO
                </span>
              }
              isDecimal
              titleFont="17px"
              suffix="%"
              value={data?.agendaments_metrics?.agendamentsTicket?.value}
            />

            <AditionalBox
              top="R$"
              title={
                <span>
                  Ticket <br />
                  Médio
                </span>
              }
              isDecimal
              titleFont="17px"
              icon={mdiCurrencyUsd}
              value={data?.ticket?.value}
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography
                variant="h4"
                style={{
                  fontSize: '20px',
                  borderTop: '2px solid',
                  borderColor: colors.secondary,
                  padding: '20px 0px 0px 0px',
                }}
                color={colors.primary}
              >
                Origem dos leads
              </Typography>
            </Grid>

            {/* cpa - cpl - roas - somente mensal */}
            {data?.know_way_metrics?.know_ways?.map(origin => (
              <CardKnow
                name={origin?.name}
                orcament={origin?.orcament}
                qtd={origin?.value}
                convert={origin?.converted}
                qtdConvert={origin?.qtdConverted}
                notConvert={origin?.notConverted}
                qtdNotConvert={origin?.qtdNotConverted}
                cpl={origin?.cpl}
                cpa={origin?.cpa}
                roas={origin?.roas}
                investment={origin?.investment}
                disabled={monthVision}
              />
            ))}
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          style={{
            borderTop: '1px dashed',
            borderBottom: '1px dashed',
            borderColor: colors.graylight,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '12px',
          }}
        >
          <Box>
            <Icon path={mdiAccountFilter} color={colors.graylight} size={2} />
          </Box>

          <Typography
            style={{ fontSize: '17px', lineHeight: '18px', fontWeight: 'bold' }}
          >
            Total de leads <br /> no período
          </Typography>

          <Divider orientation="vertical" flexItem />

          <Typography
            style={{
              color: colors.primary,
              fontSize: '20px',
              fontWeight: '700',
            }}
          >
            {data?.know_way_metrics?.leads_on_period}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(LeadsDashboard)
